export enum HttpHeader {
  AUTHORIZATION = 'Authorization',
  CONTENT_TYPE = 'Content-Type'
}
